const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: 'ease',
    speed: 600,
    prevArrow: '.card-slider-block .prev-arrow',
    nextArrow: '.card-slider-block .next-arrow'
};

export const prevArrow = `
    <button class="card-slider__prev button arrow">
        <svg class="arrow prev-arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
            <g id="Group_341" data-name="Group 341" transform="translate(1644 4992) rotate(180)">
                <g id="Arrow" transform="translate(1599 4992) rotate(-90)">
                    <rect id="Rectangle_140" data-name="Rectangle 140" width="45" height="45" rx="22.5" fill="#29c2be" />
                </g>
                <path id="Path_159" data-name="Path 159" d="M2.475,26.664l-4.95-4.95,9.62-9.62-9.62-9.62,4.95-4.95L17.044,12.095Z" transform="translate(1633.689 4963.5) rotate(90)" fill="#fff" />
            </g>
        </svg>
    </button>`;
export const nextArrow = `
    <button class="card-slider__next button arrow">
        <svg class="arrow next-arrow" xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45">
            <g id="Group_341" data-name="Group 341" transform="translate(1644 4992) rotate(180)">
                <g id="Arrow" transform="translate(1599 4992) rotate(-90)">
                    <rect id="Rectangle_140" data-name="Rectangle 140" width="45" height="45" rx="22.5" fill="#29c2be" />
                </g>
                <path id="Path_159" data-name="Path 159" d="M2.475,26.664l-4.95-4.95,9.62-9.62-9.62-9.62,4.95-4.95L17.044,12.095Z" transform="translate(1633.689 4963.5) rotate(90)" fill="#fff" />
            </g>
        </svg>
    </button>`;



jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--small' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            slidesToShow: 3,
            prevArrow: '.testimonials .prev',
            nextArrow: '.testimonials .next',
            responsive: [
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 840,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        } );
    } );
} );

jQuery( function( $ ) {
    document.querySelectorAll( '.card-slider--medium' ).forEach( slider => {
        $( slider ).slick( {
            ...options,
            prevArrow,
            nextArrow,
            slidesToShow: 2.5,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 2.5,
                    }
                },
                {
                    breakpoint: 850,
                    settings: {
                        slidesToShow: 1.5,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ],
        } );
    } );
} );